export default "__VITE_ASSET__BXvSOGSr__"